<template>
  <div>
    <h2 class="ViewHeading">Filter Management</h2>

    <div>
      <b-row
        ><b-col><br /></b-col
      ></b-row>
      <b-row>
        <b-col>
          <b-card-group deck
            ><b-card
              border-variant="info"
              header="In Stock"
              header-bg-variant="info"
              align="center"
            >
              <b-card-text
                >You have {{ this.StockCount }} Filters in stock</b-card-text
              >
              <b-card-text></b-card-text> </b-card
            ><b-card
              border-variant="warning"
              header="Due Replacement"
              header-bg-variant="warning"
              align="center"
            >
              <b-card-text
                >You have {{ this.DueCount }} Filters that are due for
                replacement in the next 28 days</b-card-text
              >
            </b-card>
            <b-card
              border-variant="danger"
              header=" Overdue Replacement "
              header-bg-variant="danger"
              align="center"
            >
              <b-card-text
                >You have {{ this.OverdueCount }} Filters that are overdue for
                replacement</b-card-text
              >
              <b-card-text></b-card-text>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
      <b-row><br /></b-row>
    </div>
    <div>
      <b-card no-body>
        <b-tabs card v-model="FilterTabs">
          <b-tab title="Tracked Filters" active>
            <div id="Table">
              <br />

              <h4>Tracked Filters</h4>
              <br />
              <div>
                <b-table
                  sticky-header
                  no-border-collapse
                  responsive
                  :items="Trackeditems"
                  :fields="Trackedfields"
                  hover
                  small
                >
                  <template v-slot:cell(7)="{ item }">
                    <div v-if="item[7] === 'Valid'">
                      <b-badge variant="success">Valid</b-badge>
                    </div>
                    <div v-if="item[7] === 'Overdue'">
                      <b-badge variant="danger">Overdue</b-badge>
                    </div>
                    <div v-if="item[7] === 'Due'">
                      <b-badge variant="warning">Due</b-badge>
                    </div>
                  </template>
                  <template v-slot:cell(Details)="{ item }">
                    <b-button
                      variant="outline-info"
                      size="sm"
                      v-on:click="showFilterNotes(item)"
                      >Show</b-button
                    >
                  </template>
                </b-table>
              </div>
            </div>
          </b-tab>
          <b-tab title="Maintenance Schedule" lazy>
            <b-card>
              <div id="Table">
                <br />
                <h4>Scheduled Filter Maintenance</h4>

                <br />
                <div>
                  <b-table
                    sticky-header
                    no-border-collapse
                    responsive
                    :items="scheduleditems"
                    :fields="scheduledfields"
                    hover
                    small
                  >
                    <!-- <template v-slot:cell(Modify)="{ item }">
                      <b-button
                        variant="outline-info"
                        size="sm"
                        v-on:click="modifyFilterBooking(item)"
                        >Modify</b-button
                      >
                    </template> -->

                    <template v-slot:cell(Modify)="{ item }">
                      <b-button
                        v-if="
                          item[13] == 'FALSE' ||
                            item[13] == '' ||
                            item[13] == null
                        "
                        size="sm"
                        variant="outline-info"
                        v-on:click="modifyFilterBooking(item)"
                        >Modify</b-button
                      >
                      <b-badge v-if="item[13] == 'TRUE'">Under Edit</b-badge>
                    </template>
                  </b-table>
                  <b-row>
                    <b-col class="text-left">
                      <b-button
                        variant="outline-secondary"
                        size="sm"
                        v-on:click="ShowNewBooking()"
                        ><BIconPlus></BIconPlus>
                        Schedule New Maintenance
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-card>
          </b-tab>
          <b-tab title="Install Filters">
            <br />

            <b-row>
              <b-col class="text-center"> <h4>Filter Install Form</h4> </b-col>
            </b-row>
            <br />
            <b-row class="mt-2"
              ><b-col cols="4" class="modify-text-left">Name</b-col>
              <b-col cols="8">{{ this.name }} </b-col>
            </b-row>
            <br />

            <b-row class="mt-2">
              <b-col cols="4">Type</b-col>
              <b-col cols="8">
                <b-form-select
                  v-model="InstallForm.Type"
                  :options="filters"
                  required
                  v-on:change="updateAccessoryLists()"
                ></b-form-select
              ></b-col>
            </b-row>
            <br />
            <section v-if="ShowForm == true">
              <b-row class="mt-2">
                <b-col cols="4">Accessory ID</b-col>
                <b-col cols="8"
                  ><b-form-select
                    v-model="InstallForm.accessoryID"
                    :options="filtersID"
                    required
                  ></b-form-select
                ></b-col>
              </b-row>
              <br />
              <b-row class="mt-2">
                <b-col cols="4">Outlet ID</b-col>
                <b-col cols="8"
                  ><b-form-select
                    v-model="InstallForm.OutletID"
                    :options="outletID"
                    required
                  ></b-form-select
                ></b-col>
              </b-row>
              <br />
              <b-row class="mt-2">
                <b-col cols="4">Choose Date</b-col>
                <b-col cols="8"
                  ><b-form-datepicker
                    v-model="InstallForm.Date"
                  ></b-form-datepicker
                ></b-col>
              </b-row>
              <br />
              <b-row class="mt-2">
                <b-col cols="4">Choose Time</b-col>
                <b-col cols="8">
                  <b-form-timepicker
                    locale="en"
                    placeholder=""
                    v-model="InstallForm.Time"
                  ></b-form-timepicker
                ></b-col>
              </b-row>
              <br />
              <b-row>
                <b-col></b-col>
                <b-col class="text-center"
                  ><b-button
                    variant="outline-info"
                    small
                    v-on:click="SubmitInstall()"
                    >Submit</b-button
                  ></b-col
                >
                <b-col class="text-center">
                  <b-button
                    variant="outline-danger"
                    small
                    v-on:click="ResetInstall()"
                    >Reset</b-button
                  ></b-col
                >
                <b-col></b-col>
              </b-row>
            </section>
          </b-tab>
          <b-tab title="Current Stock">
            <div id="Table">
              <br />
              <h4>Current Stock</h4>
              <br />
              <b-card-group>
                <b-card header="30 Day Inline" header-bg-variant="light"
                  ><b-avatar rounded variant="light"
                    ><p class="count">{{ this.ThirtyInlineCount }}</p></b-avatar
                  ></b-card
                >
                <b-card header="30 Day Point of Use" header-bg-variant="light"
                  ><b-avatar rounded variant="light"
                    ><p class="count">{{ this.ThirtyDayCount }}</p></b-avatar
                  ></b-card
                >
                <b-card header="90 Day Inline" header-bg-variant="light"
                  ><b-avatar rounded variant="light"
                    ><p class="count">{{ this.NinetyDayCount }}</p></b-avatar
                  ></b-card
                >
              </b-card-group>
            </div>
          </b-tab>
          <b-tab title="Completed" lazy>
            <br />
            <h4 class="centered">Completed Changes</h4>
            <br />
            <b-table
              sticky-header
              no-border-collapse
              responsive
              hover
              small
              show-empty
              empty-text="You don't curently have any results to show"
              :items="completeActions"
              :fields="completeActionsHeaders"
            >
            </b-table>
          </b-tab>
        </b-tabs>
      </b-card>
      <b-modal
        ref="FilterManagementModal"
        id="FilterManagementModal"
        title="Filter Management"
        content-class="Modal"
        header-bg-variant="light"
        header-text-variant="dark"
        ok-only
        ok-variant="outline-info"
      >
        <h3>{{ this.ID }}</h3>
        <b-card :header-bg-variant="statusColour">
          <template #header>
            Status: {{ FilterStatus }} - {{ FilterDueReplaced }}
          </template>
          <b-row>
            <b-col class="text-center">
              <h4>{{ this.FilterType }}</h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-center"
              ><b>Location: </b> <em>{{ this.FilterLocation }}</em></b-col
            >
          </b-row>
          <b-row>
            <b-col class="text-center"
              ><b>Position: </b> <em>{{ this.FilterRoom }}</em></b-col
            >
          </b-row>
          <br />
          <b-row>
            <b-col class="text-center"
              ><b>Description:</b> <em>{{ this.FilterDesc }}</em></b-col
            >
          </b-row>
          <br />
          <b-row>
            <b-col class="text-center"
              ><b>Last Changed: </b>
              <em>{{ this.FilterLastChanged }}</em></b-col
            >
          </b-row>
          <br />
          <b-row v-if="FilterStatus == 'Overdue'">
            <b-col>
              <b-button
                variant="outline-info"
                v-on:click="goToInstallFilter(ID, FilterType)"
              >
                Install New Filter
              </b-button>
              <b-button variant="outline-info" v-on:click="clearFilter(ID)">
                Clear Filter Alert
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-modal>
      <b-modal
        ref="ModifyFilterBookingModal"
        id="ModifyFilterBookingModal"
        title="Filter Maintenance Booking"
        content-class="Modal"
        header-bg-variant="light"
        header-text-variant="dark"
        hide-footer
      >
        <b-card>
          <b-row class="mt-2"
            ><b-col cols="4" class="modify-text-left">Outlet ID</b-col>
            <b-col cols="8">
              <input
                type="text"
                v-model="ModifiedBooking.OutletID"
                required/></b-col
          ></b-row>
          <b-row class="mt-2"
            ><b-col cols="4" class="modify-text-left">Location</b-col>
            <b-col cols="8">
              <input type="text" v-model="ModifiedBooking.Location" required />
            </b-col>
          </b-row>
          <b-row class="mt-2"
            ><b-col cols="4" class="modify-text-left">Room</b-col>
            <b-col cols="8"
              ><input type="text" v-model="ModifiedBooking.Area" required />
            </b-col>
          </b-row>
          <b-row class="mt-2"
            ><b-col cols="4" class="modify-text-left">Description</b-col>
            <b-col cols="8"
              ><input
                type="text"
                v-model="ModifiedBooking.Description"
                required
              />
            </b-col>
          </b-row>
          <b-row class="mt-2"
            ><b-col cols="4" class="modify-text-left">Arranged By</b-col>
            <b-col cols="8"> {{ ModifiedBooking.ArrangedBy }} </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col
              >Scheduled Date:
              <b-form-datepicker
                locale="en"
                :placeholder="this.ModifiedBooking.Date"
                v-model="ModifiedBooking.Date"
              ></b-form-datepicker
            ></b-col>
          </b-row>
          <b-row>
            <b-col
              >Scheduled Time:
              <b-form-timepicker
                locale="en"
                :placeholder="this.ModifiedBooking.Time"
                v-model="ModifiedBooking.Time"
              ></b-form-timepicker
            ></b-col>
          </b-row>
          <b-row
            ><b-col><br /></b-col
          ></b-row>
          <b-row>
            <b-col
              ><b-button
                variant="outline-info"
                v-on:click="SubmitModifiedBooking()"
                >Submit Changes</b-button
              ></b-col
            >
            <b-col
              ><b-button
                variant="outline-info"
                v-on:click="CancelModifiedBooking()"
                >Cancel Changes</b-button
              ></b-col
            >
          </b-row>
          <b-row
            ><b-col><br /></b-col
          ></b-row>
        </b-card>
      </b-modal>
      <b-modal
        ref="NewBookingModal"
        id="NewBookingModal"
        title="New Maintenance Booking"
        content-class="Modal"
        header-bg-variant="light"
        header-text-variant="dark"
        hide-footer
      >
        <b-card
          header-bg-variant="dark"
          border-variant="light"
          bg-variant="light"
        >
          <template #header>
            <h6 class="testHeader">New Maintenance Request Form</h6>
          </template>
          <template #footer>
            <b-row>
              <b-col class="centered">
                <b-button
                  v-on:click="SubmitBooking()"
                  variant="outline-info"
                  small
                  >Submit</b-button
                >
                <b-button
                  v-on:click="ResetBooking()"
                  variant="outline-info"
                  small
                  >Cancel</b-button
                >
              </b-col>
            </b-row>
          </template>
          <h5 class="accessoriesHeader">Request Type</h5>
          <b-row>
            <b-col>
              <b-form-select
                :options="filters"
                v-model="newBooking.TestType"
              ></b-form-select>
            </b-col>
          </b-row>
          <br />
          <hr />
          <b-row>
            <b-col>
              <b-form-input
                id="OutletID"
                v-model="newBooking.NoOfOutlets"
                placeholder="No of Outlets"
                required
              ></b-form-input>
            </b-col>
            <b-col>
              <b-form-input
                id="Area"
                v-model="newBooking.Room"
                placeholder="Room/Area"
                required
              ></b-form-input>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col>
              <b-form-input
                id="LocationNote"
                v-model="newBooking.Note"
                placeholder="Location Note"
                required
              ></b-form-input>
            </b-col>
          </b-row>
          <hr />
          <b-row
            ><b-col>
              <h5 class="accessoriesHeader">Date</h5>

              <b-form-datepicker
                id="input-4"
                v-model="newBooking.Date"
                class="mb-2"
              ></b-form-datepicker>
            </b-col>
            <b-col>
              <h5 class="accessoriesHeader">Time</h5>

              <b-form-timepicker
                locale="en"
                v-model="newBooking.Time"
              ></b-form-timepicker>
            </b-col>
          </b-row>
          <hr />
          <h5 class="accessoriesHeader">Contact Information</h5>
          <b-row>
            <b-col>
              <b-form-input
                id="input-2"
                v-model="newBooking.Name"
                placeholder="Enter name"
                required
              ></b-form-input>
            </b-col>

            <b-col>
              <b-form-input
                placeholder="Email Address"
                v-model="newBooking.Email"
              ></b-form-input>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col>
              <b-form-input
                id="input-2"
                v-model="newBooking.ContactNote"
                placeholder="Note for Contact"
                required
                max="150"
              ></b-form-input>
            </b-col>
          </b-row>
        </b-card>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { BIconPlus } from "bootstrap-vue";

export default {
  computed: {},
  components: {
    BIconPlus,
  },

  data() {
    return {
      ShowForm: false,
      name: localStorage.getItem("fullname"),
      form: {
        name: localStorage.getItem("fullname"),
        Type: null,
        newRADate: null,
        FilterID: null,
        OutletID: null,
      },
      filters: [
        { text: "Select Filter Type", value: null },
        "30 Day Inline",
        "30 Day Point of Use",
        "90 Day Inline",
      ],
      filtersID: [
        { text: "Select Filter ID", value: null },
        "992829956",
        "998474781",
        "920751649",
        "929776707",
        "958527771",
        "926279515",
      ],
      outletID: [],
      UserHeaders: [],
      response: null,
      ArrTest: [],
      perPage: 5,
      currentPage: 1,
      rowDblClickHandler: "",
      modal: false,
      Trackedfields: [
        {
          key: "0",
          label: "OutletID",
          stickyColumn: true,
          isRowHeader: true,
          variant: "primary",
        },
        { key: "8", label: "FilterID" },
        { key: "2", label: "Location" },
        { key: "3", label: "Position" },
        { key: "1", label: "Description" },
        { key: "4", label: "Filter Type" },
        { key: "5", label: "Last Changed" },
        { key: "6", label: "Due Replaced" },
        { key: "7", label: "Status" },
        { key: "Details" },
      ],
      Trackeditems: [],
      scheduledfields: [
        {
          key: "0",
          label: "Service ID",
          stickyColumn: true,
          isRowHeader: true,
          variant: "primary",
        },
        { key: "9", label: "Endpoint ID" },
        { key: "1", label: "Type" },
        { key: "2", label: "Category" },
        { key: "3", label: "Service Note" },
        { key: "4", label: "Room/Area" },
        { key: "5", label: " Location Note" },
        { key: "6", label: "Arranged By" },
        { key: "7", label: "Scheduled Date" },
        { key: "8", label: "Scheduled Time" },
        { key: "Modify" },
      ],
      scheduleditems: [],
      selectedlocation: localStorage.getItem("CurrentLocation"),
      ID: "",
      FilterLocation: "",
      FilterRoom: "",
      FilterDesc: "",
      FilterType: "",
      FilterLastChanged: "",
      FilterDueReplaced: "",
      FilterStatus: "",
      statusColour: "",
      var1: "",
      var2: "",
      var3: "",
      var4: "",
      var5: "",
      var6: "",
      var7: "",
      var8: "",
      newBooking: {
        OutletID: null,
        Room: null,
        Note: null,
        CheckType: null,
        Name: null,
        Type: null,
        Date: null,
        Email: null,
      },
      ModifiedBooking: {
        OutletID: null,
        Area: null,
        Description: null,
        Type: null,
        ArrangedBy: null,
        Date: null,
        Time: null,
        Location: null,
      },
      InstallForm: {
        name: null,
        Type: null,
        Date: null,
        accessoryID: null,
        OutletID: null,
      },
      StockCount: "",
      OverdueCount: "",
      DueCount: "",
      ThirtyDayCount: "",
      ThirtyInlineCount: "",
      NinetyDayCount: "",
      FilterID: "",
      FilterTabs: 0,
      completeActionsHeaders: [
        {
          key: "0",
          label: "OutletID",
          variant: "primary",
        },
        { key: "7", label: "Location" },
        { key: "6", label: "Position" },
        { key: "1", label: "Filter Type" },
        { key: "2", label: "Description" },
        { key: "3", label: "Date Installed" },
        { key: "4", label: "Time Installed" },
        { key: "5", label: "Changed By" },
      ],
      completeActions: [],
    };
  },

  beforeMount() {},

  mounted() {
    let LookUpUrlOutlets =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/outlets";
    let LookUpHeadersOutlets = this.$apikeyPost;
    let LookUpRequestOutlets = {
      RequestType: "LoadOutletIDsLocation",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };

    axios
      .post(LookUpUrlOutlets, LookUpRequestOutlets, LookUpHeadersOutlets)
      .then((response) => {
        response;
        this.outletID = response.data.Values;
        // this.TrackedAccessories = response.data.Values;
      });

    let LookUpUrlFilterCounts =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersFilterCounts = this.$apikeyPost;
    let LookUpRequestFilterCounts = {
      ServiceType: "FilterManagement",
      RequestType: "FilterCounts",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(
        LookUpUrlFilterCounts,
        LookUpRequestFilterCounts,
        LookUpHeadersFilterCounts
      )
      .then((response) => {
        (this.StockCount = response.data.StockCount),
          (this.OverdueCount = response.data.OverdueCount),
          (this.DueCount = response.data.DueCount);
      });

    let LookUpUrlAccessories =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersAccessories = this.$apikeyPost;
    let LookUpRequestAccessories = {
      ServiceType: "FilterManagement",
      RequestType: "LoadTrackedFilters",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(
        LookUpUrlAccessories,
        LookUpRequestAccessories,
        LookUpHeadersAccessories
      )
      .then((response) => {
        this.Trackeditems = response.data.Values;
      });

    let LookUpUrlCurrentStock =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersCurrentStock = this.$apikeyPost;
    let LookUpRequestCurrentStock = {
      ServiceType: "FilterManagement",
      RequestType: "LoadCurrentFilterStock",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(
        LookUpUrlCurrentStock,
        LookUpRequestCurrentStock,
        LookUpHeadersCurrentStock
      )
      .then((response) => {
        (this.ThirtyInlineCount =
          response.data.Values["30DayInline"].Blue +
          response.data.Values["30DayInline"].Red +
          response.data.Values["30DayInline"].Green +
          response.data.Values["30DayInline"].Purple),
          (this.ThirtyDayCount =
            response.data.Values["30DayPointofUse"].Blue +
            response.data.Values["30DayPointofUse"].Red +
            response.data.Values["30DayPointofUse"].Green +
            response.data.Values["30DayPointofUse"].Purple),
          (this.NinetyDayCount =
            response.data.Values["90DayInline"].Blue +
            response.data.Values["90DayInline"].Red +
            response.data.Values["90DayInline"].Green +
            response.data.Values["90DayInline"].Purple);
      });

    let LookUpUrlCompleted =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersCompleted = this.$apikeyPost;
    let LookUpRequestCompleted = {
      ServiceType: "FilterManagement",
      RequestType: "LoadFilterChanges",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(LookUpUrlCompleted, LookUpRequestCompleted, LookUpHeadersCompleted)
      .then((response) => {
        this.completeActions = response.data.Values;
      });

    let LookUpUrlScheduled =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersScheduled = this.$apikeyPost;
    let LookUpRequestScheduled = {
      ServiceType: "FilterManagement",
      RequestType: "LoadScheduledFilters",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(LookUpUrlScheduled, LookUpRequestScheduled, LookUpHeadersScheduled)
      .then((response) => {
        this.scheduleditems = response.data.Values;
      });
  },

  methods: {
    resetmodal() {
      this.$refs["DeviceAttachModal"].hide();
    },

    ShowNewBooking() {
      this.$refs["NewBookingModal"].show();
    },

    goToInstallFilter(id, type) {
      this.$refs["FilterManagementModal"].hide();
      this.InstallForm.Type = type;
      this.FilterTabs = 2;
      this.updateAccessoryLists(id);
      // this.InstallForm.OutletID = id;
    },

    clearFilter(id) {
      // UPDATE THE REQUEST TYPE

      let LookUpUrlScheduledTests =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersScheduledTests = this.$apikeyPost;
      let LookUpRequestScheduledTests = {
        ServiceType: "FilterManagement",
        RequestType: "UpdateFilterStatus",
        DataDict: [
          {
            Status: "Dormant",
            OutletID: id,
            FilterID: this.FilterID,
          },
        ],
      };
      axios
        .post(
          LookUpUrlScheduledTests,
          LookUpRequestScheduledTests,
          LookUpHeadersScheduledTests
        )
        .then((response) => {
          response;
          this.$refs["FilterManagementModal"].hide();

          this.resetTracked();
        });
    },

    resetTracked() {
      let LookUpUrlAccessories =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersAccessories = this.$apikeyPost;
      let LookUpRequestAccessories = {
        ServiceType: "FilterManagement",
        RequestType: "LoadTrackedFilters",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpUrlAccessories,
          LookUpRequestAccessories,
          LookUpHeadersAccessories
        )
        .then((response) => {
          this.Trackeditems = response.data.Values;
        });
    },

    showFilterNotes(item) {
      (this.ID = item[0]),
        (this.FilterLocation = item[2]),
        (this.FilterRoom = item[3]),
        (this.FilterDesc = item[1]),
        (this.FilterType = item[4]),
        (this.FilterLastChanged = item[5]),
        (this.FilterDueReplaced = item[6]),
        (this.FilterStatus = item[7]);
      this.FilterID = item[8];

      if (this.FilterStatus == "Valid") {
        this.statusColour = "success";
      } else if (this.FilterStatus == "Due") {
        this.statusColour = "warning";
      } else if (this.FilterStatus == "Overdue") {
        this.statusColour = "danger";
      } else {
        this.statusColour = "secondary";
      }
      this.$refs["FilterManagementModal"].show(
        this.ID,
        this.FilterLocation,
        this.FilterRoom,
        this.FilterDesc,
        this.FilterType,
        this.FilterLastChanged,
        this.FilterDueReplaced,
        this.FilterStatus,
        this.FilterID
      );
    },
    SubmitBooking() {
      this.newBooking.Type = "WMS";
      // let name = localStorage.getItem("fullname");

      if (
        this.newBooking.Type == null ||
        this.newBooking.Room == null ||
        this.newBooking.Note == null ||
        this.newBooking.Date == null ||
        this.newBooking.TestType == null ||
        this.newBooking.Name == null ||
        this.newBooking.NoOfOutlets == null ||
        this.newBooking.Email == null
      ) {
        alert("Please complete all fields to submit Booking request");
      } else {
        // let LookUpUrlScheduledTests =
        //   "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        //   this.$environment +
        //   "/service";
        // let LookUpHeadersScheduledTests = this.$apikeyPost;
        // let LookUpRequestScheduledTests = {
        //   RequestType: "CreateRequest",
        //   RequestVariable: "",
        //   DataDict: [
        //     {
        //       OriginID: "",
        //       Type: "WMS",
        //       Category: "Filter Management",
        //       ServiceNote:
        //         this.newBooking.NoOfOutlets + " " + this.newBooking.TestType,
        //       EndpointType: "",
        //       EndpointID: "",
        //       Location: this.selectedlocation,
        //       DeptFloor: this.newBooking.Room,
        //       Position: "",
        //       LocationNote: this.newBooking.Note,
        //       ArrangedBy: name,
        //       ScheduledDate: this.newBooking.Date,
        //       ScheduledTime: this.newBooking.Time,
        //       AssignedTo: "",
        //       ContactName: this.newBooking.Name,
        //       ContactEmail: this.newBooking.Email,
        //       ContactNote: this.newBooking.ContactNote,
        //     },
        //   ],
        // };
        // axios
        //   .post(
        //     LookUpUrlScheduledTests,
        //     LookUpRequestScheduledTests,
        //     LookUpHeadersScheduledTests
        //   )
        //   .then((response) => {
        //     response;

        //     this.newBooking = {};
        //     this.ResetBooking();
        //   });
        let EmailService = {
          ToEmail: "Support@seraphprotect.online",

          EmailText:
            "New Shower Maintenance Request raised by user.\\n\\n" +
            this.selectedlocation +
            "\\n" +
            this.newBooking.Name +
            "\\n" +
            this.newBooking.Email +
            "\\n" +
            "Contact Note - " +
            this.newBooking.ContactNote +
            "\\n\\n" +
            "Maintenance Information " +
            "\\n\\n" +
            "Maintenance Type - " +
            this.newBooking.TestType +
            "\\n" +
            "Room - " +
            this.newBooking.Room +
            "\\n" +
            "Number of Outlets  - " +
            this.newBooking.NoOfOutlets +
            "\\n" +
            "Location Note " +
            this.newBooking.Note +
            " Date and Time - " +
            this.newBooking.Date +
            " at " +
            this.newBooking.Time,

          EmailSubject: "New Filter Maintenance Booking ",
        };

        let EmailPosturl =
          "https://d9py0urct8.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/emailgateway";

        let EmailPostHeaders = this.$apikeyPost;

        axios
          .post(EmailPosturl, EmailService, EmailPostHeaders)
          .then((response) => {
            response;
            this.ResetBooking();
          })
          .catch((err) => {
            "Error: ===", err;
          });
        alert(
          "Your Request has been submitted, A staff member will be in touch."
        );

        // alert("Booking Request has been submitted");
      }
    },
    ResetBooking() {
      this.newBooking = {};
      this.resetBookingTable();
      this.$refs["NewBookingModal"].hide();
    },

    resetBookingTable() {
      let LookUpUrlFilterCounts =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersFilterCounts = this.$apikeyPost;
      let LookUpRequestFilterCounts = {
        ServiceType: "FilterManagement",
        RequestType: "FilterCounts",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpUrlFilterCounts,
          LookUpRequestFilterCounts,
          LookUpHeadersFilterCounts
        )
        .then((response) => {
          (this.StockCount = response.data.StockCount),
            (this.OverdueCount = response.data.OverdueCount),
            (this.DueCount = response.data.DueCount);
        });

      let LookUpUrlAccessories =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersAccessories = this.$apikeyPost;
      let LookUpRequestAccessories = {
        ServiceType: "FilterManagement",
        RequestType: "LoadTrackedFilters",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpUrlAccessories,
          LookUpRequestAccessories,
          LookUpHeadersAccessories
        )
        .then((response) => {
          this.Trackeditems = response.data.Values;
        });

      let LookUpUrlCurrentStock =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersCurrentStock = this.$apikeyPost;
      let LookUpRequestCurrentStock = {
        ServiceType: "FilterManagement",
        RequestType: "LoadCurrentFilterStock",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpUrlCurrentStock,
          LookUpRequestCurrentStock,
          LookUpHeadersCurrentStock
        )
        .then((response) => {
          (this.ThirtyInlineCount =
            response.data.Values["30DayInline"].Blue +
            response.data.Values["30DayInline"].Red +
            response.data.Values["30DayInline"].Green +
            response.data.Values["30DayInline"].Purple),
            (this.ThirtyDayCount =
              response.data.Values["30DayPOU"].Blue +
              response.data.Values["30DayPOU"].Red +
              response.data.Values["30DayPOU"].Green +
              response.data.Values["30DayPOU"].Purple),
            (this.NinetyDayCount =
              response.data.Values["90DayInline"].Blue +
              response.data.Values["90DayInline"].Red +
              response.data.Values["90DayInline"].Green +
              response.data.Values["90DayInline"].Purple);
        });

      let LookUpUrlCompleted =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersCompleted = this.$apikeyPost;
      let LookUpRequestCompleted = {
        ServiceType: "FilterManagement",
        RequestType: "LoadFilterChanges",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpUrlCompleted,
          LookUpRequestCompleted,
          LookUpHeadersCompleted
        )
        .then((response) => {
          this.completeActions = response.data.Values;
        });

      let LookUpUrlScheduled =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersScheduled = this.$apikeyPost;
      let LookUpRequestScheduled = {
        ServiceType: "FilterManagement",
        RequestType: "LoadScheduledFilters",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpUrlScheduled,
          LookUpRequestScheduled,
          LookUpHeadersScheduled
        )
        .then((response) => {
          this.scheduleditems = response.data.Values;
        });
    },

    modifyFilterBooking(item) {
      this.ModifiedBooking = {};
      this.ModifiedBooking = {
        OutletID: item[9],
        Area: item[5],
        Description: item[3],
        Type: item[1],
        ArrangedBy: item[6],
        Date: item[7],
        Time: item[8],
        Location: item[4],
        ServiceID: item[0],
      };
      this.$refs["ModifyFilterBookingModal"].show(this.ModifiedBooking);
    },

    SubmitModifiedBooking() {
      // if (
      //   this.ModifiedBooking.Area == "" ||
      //   this.ModifiedBooking.Description == "" ||
      //   this.ModifiedBooking.Type == "" ||
      //   this.ModifiedBooking.ArrangedBy == "" ||
      //   this.ModifiedBooking.Date == "" ||
      //   this.ModifiedBooking.Time == ""
      // ) {
      //   alert("Please complete all fields to submit Booking request");
      // } else {
      //   let LookUpUrl =
      //     "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      //     this.$environment +
      //     "/service";
      //   let LookUpHeaders = this.$apikeyPost;
      //   this.LookUpRequest = {
      //     RequestType: "ModifyRequest",

      //     RequestVariable: "",

      //     DataDict: [
      //       {
      //         ServiceNote: this.ModifiedBooking.Description,
      //         DeptFloor: this.ModifiedBooking.Area,
      //         LocationNote: "",
      //         ScheduledDate: this.ModifiedBooking.Date,
      //         ScheduledTime: this.ModifiedBooking.Time,
      //         ServiceID: this.ModifiedBooking.ServiceID,
      //       },
      //     ],
      //   };

      //   axios
      //     .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      //     .then((response) => {
      //       response;
      //       alert("Update Submitted");
      //       this.$refs["ModifyFilterBookingModal"].hide();
      //       this.resetBookings();
      //     });

      //   this.$refs["ModifyFilterBookingModal"].hide();
      // }

      if (
        this.ModifiedBooking.Area == "" ||
        this.ModifiedBooking.Description == "" ||
        this.ModifiedBooking.Room == "" ||
        this.ModifiedBooking.Date == "" ||
        this.ModifiedBooking.Time == ""
      ) {
        alert("Please complete all fields to submit Booking request");
      } else {
        let EmailService = {
          ToEmail: "Support@seraphprotect.online",

          EmailText:
            "Modify Appointment Request raised by user.\\n\\n" +
            this.selectedlocation +
            "\\n" +
            this.name +
            "\\n\\n" +
            "Appointment Information " +
            "\\n\\n" +
            this.ModifiedBooking.ServiceID +
            "\\n" +
            "Type - " +
            this.ModifiedBooking.Description +
            "\\n " +
            this.ModifiedBooking.Type +
            "\\n" +
            "Room - " +
            this.ModifiedBooking.Room +
            "\\n" +
            "Area  - " +
            this.ModifiedBooking.Area +
            "\\n" +
            "New Date and Time - " +
            this.ModifiedBooking.Date +
            " at " +
            this.ModifiedBooking.Time,

          EmailSubject: "Service Request Booking Modification ",
        };

        let EmailPosturl =
          "https://d9py0urct8.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/emailgateway";

        let EmailPostHeaders = this.$apikeyPost;

        axios
          .post(EmailPosturl, EmailService, EmailPostHeaders)
          .then((response) => {
            response;
          })
          .catch((err) => {
            "Error: ===", err;
          });
        alert(
          "Your Request has been submitted,An Angel Guard staff member will be in touch."
        );

        let ScheduledUpdateURL =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/service";
        let ScheduledUpdateHeaders = this.$apikeyPost;
        let ScheduledUpdateRequest = {
          RequestType: "UpdateService",
          RequestVariable: "",
          DataDict: [
            {
              ServiceID: this.ModifiedBooking.ServiceID,
              Status: "",
              UnderEdit: "TRUE",
            },
          ],
        };
        axios
          .post(
            ScheduledUpdateURL,
            ScheduledUpdateRequest,
            ScheduledUpdateHeaders
          )
          .then((response) => {
            response;
            this.resetBookings();
          });
        this.$refs["ModifyFilterBookingModal"].hide();
      }
    },
    resetBookings() {
      this.ModifiedBooking = [];
      this.resetBookingTable();
      this.$refs["ModifyFilterBookingModal"].hide();
    },
    CancelModifiedBooking() {
      this.ModifiedBooking = {};
      this.$refs["ModifyFilterBookingModal"].hide();
    },
    SubmitInstall() {
      if (
        this.InstallForm.Date == null ||
        this.InstallForm.Time == null ||
        this.InstallForm.OutletID == null ||
        this.InstallForm.accessoryID == null ||
        this.InstallForm.Type == null
      ) {
        alert("Please complete all fields to continue");
      } else {
        alert("Installation Successfully Uploaded");
        this.InstallForm.name = localStorage.getItem("fullname");
        let LookUpUrlScheduledTests =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/wms";
        let LookUpHeadersScheduledTests = this.$apikeyPost;
        let LookUpRequestScheduledTests = {
          ServiceType: "FilterManagement",
          RequestType: "AddFilterOutlet",
          DataDict: [
            {
              Location: this.selectedlocation,
              OutletID: this.InstallForm.OutletID,
              FilterID: this.InstallForm.accessoryID,
              DateFitted: this.InstallForm.Date,
              FittedBy: this.InstallForm.name,
              FilterType: this.InstallForm.Type,
              InstalledTime: this.InstallForm.Time,
              ServiceID: "",
            },
          ],
        };
        axios
          .post(
            LookUpUrlScheduledTests,
            LookUpRequestScheduledTests,
            LookUpHeadersScheduledTests
          )
          .then((response) => {
            response;
            this.ShowForm = false;

            // this.$refs["newTempBooking"].hide();
            // this.resetScheduledChecks();

            this.InstallForm = {};
          });
        this.ResetInstall();
      }
    },
    ResetInstall() {
      this.InstallForm = {
        name: null,
        Type: null,
        Date: null,
        accessoryID: null,
        OutletID: null,
      };
      this.selected = null;
      let LookUpUrlOutlets =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/outlets";
      let LookUpHeadersOutlets = this.$apikeyPost;
      let LookUpRequestOutlets = {
        RequestType: "LoadOutletIDsLocation",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };

      axios
        .post(LookUpUrlOutlets, LookUpRequestOutlets, LookUpHeadersOutlets)
        .then((response) => {
          response;
          this.outletID = response.data.Values;
          // this.TrackedAccessories = response.data.Values;
        });
    },
    updateAccessoryLists(id) {
      let LookUpUrlScheduledTests =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersScheduledTests = this.$apikeyPost;
      let LookUpRequestScheduledTests = {
        RequestType: "LoadFilterTypeUnassignedIDs",
        ServiceType: "FilterManagement",
        DataDict: [
          {
            Location: this.selectedlocation,
            FilterType: this.InstallForm.Type,
          },
        ],
      };
      axios
        .post(
          LookUpUrlScheduledTests,
          LookUpRequestScheduledTests,
          LookUpHeadersScheduledTests
        )
        .then((response) => {
          this.ShowForm = true;
          this.filtersID = [];
          this.filtersID = response.data.Values;
          this.InstallForm.accessoryID = "";
          this.InstallForm.OutletID = "";
          this.InstallForm.Date = "";
          this.InstallForm.Time = "";

          if (id != null) {
            this.InstallForm.OutletID = id;
          }

          // this.$refs["newTempBooking"].hide();
          // this.resetScheduledChecks();
        });
    },
  },
};
</script>

<style>
#Table {
  margin: auto;
  text-align: center;
}

#cancel-label {
  color: white;
  font-size: large;
}

.modal {
  text-align: center;
}

.test {
  float: right;
}

.count {
  margin: auto;
}
</style>
